import SeoHead from "@/components/SeoHead";
import classes from "./styles.module.scss";
import Title from "@/ui/Title";
import { projects_helper } from "@/helpers/projects_helper";
import ProjectCard from "@/components/ProjectCard";

export default function ProjectsPage({title, canonical, projects}) {

  const page = {
    title: {
      path: "projects.hero.title",
      placeholder: "Projects",
    },
  }

  const projectArray = [[]];
  let j = 0;
  projects.forEach((project, index) => {
    if(index > 0 && index % 5 == 0) {
      projectArray.push([]);
      j++;
    }
    projectArray[j].push(project);
  });

  return (
    <>
      <SeoHead title={title} canonical={canonical} />
      <div className={classes.hero}>
        <Title title={page.title} className={`text-white ${classes.title}`} tag="h2" />
      </div>
      <div className={classes.content}>
        {
          projectArray.map((projects, i) => {
            return <div key={i} className={classes.hide_tab}>
              {
                projects.length > 0 &&
                <div className={`${classes.row}`}>
                  { projects[0] ? <ProjectCard project={projects[0]} /> : <div className={classes.placeholders}></div> }
                  { projects[1] ? <ProjectCard project={projects[1]} /> : <div className={classes.placeholders}></div> }
                </div>
              }
              {
                projects.length > 2 &&
                <div className={`${classes.row}`}>
                { projects[2] ? <ProjectCard project={projects[2]} /> : <div className={classes.placeholders}></div> }
                { projects[3] ? <ProjectCard project={projects[3]} /> : <div className={classes.placeholders}></div> }
                { projects[4] ? <ProjectCard project={projects[4]} /> : <div className={classes.placeholders}></div> }
                </div>
              }
            </div>
          })
        }
        {
          projects.map((project, index) => {
            return <div className={classes.show_tab} key={index}>
              <ProjectCard project={project} />
            </div>
          })
        }
      </div>
    </>
  );
}

export async function getStaticProps({ }) {
  const projects = projects_helper.fetch();
  return {
    props: {
      title: "Projects",
      canonical: '/projects',
      projects,
    },
  };
}